import { defineAsyncComponent } from 'vue';
import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions, ModalOptionWidth } from '@/core/modals/ModalState';

class ConsentPageOverlayService extends AbstractModalService {
    public show(contentUrl: string, options?: Partial<ModalOptions>) {
        return this.showModal({
            component: defineAsyncComponent(() => import(
                '@/project/app/content-pages/ConsentOverlay.vue')),
            componentAttrs: {
                contentUrl
            },
            options: {
                ...options,
                usePanelWrapper: true,
                contentMaxHeight: false,
                componentHandlesOverflow: true,
                width: ModalOptionWidth.Wide,
            }
        });
    }
}

export default new ConsentPageOverlayService();
